import React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { Button } from '../button/Button';
import { Icon } from '../icon/Icon';
import { mcClose } from '@mc/react-ui-icons';
import { Card } from '../card/Card';
import { IProps } from '../common/props';
import { Col, Row } from '../row';

export type ValueInputDetailProps<API_TYPE, VAL_TYPE> = IProps & {
  value: any;
  onChange: ((val?: VAL_TYPE | undefined) => void) | undefined;
  getItemName: ((item: API_TYPE) => {}) | undefined;
  renderExtra?: (
    value: VAL_TYPE,
    onChange: ((val?: VAL_TYPE | undefined) => void) | undefined,
    disabled?: boolean
  ) => React.ReactNode;
  readOnly?: boolean;
  disabled?: boolean;
  renderItemContent?:
    | ((item: API_TYPE, name: string) => React.ReactNode)
    | undefined;
};

export const ValueInputDetail = <API_TYPE = {}, VAL_TYPE = API_TYPE>({
  value,
  onChange,
  readOnly,
  disabled,
  renderItemContent,
  getItemName,
  renderExtra,
  className,
  style,
  title,
  dataTest,
}: ValueInputDetailProps<API_TYPE, VAL_TYPE>) => {
  return (
    <Card
      mode={'view'}
      className={classNames(className, Classes.VALUE_INPUT_DETAIL)}
      title={title}
      style={style}
      dataTest={dataTest}
    >
      <Row>
        <Col className={Classes.VALUE_INPUT_DETAIL_CONTENT}>
          {renderItemContent ? (
            renderItemContent(value, getItemName?.(value) ?? value?.name)
          ) : (
            <span className="item-text">
              {getItemName?.(value) ?? value?.name}
            </span>
          )}
        </Col>
        {!readOnly && (
          <Col xs={'auto'} className={Classes.VALUE_INPUT_DETAIL_EXTRA}>
            {renderExtra ? (
              renderExtra(value, onChange, disabled)
            ) : (
              <Button
                style={'link'}
                icon={<Icon icon={mcClose} />}
                title={'Smazat hodnotu'}
                onClick={() => onChange?.(undefined)}
                disabled={disabled}
              />
            )}
          </Col>
        )}
      </Row>
    </Card>
  );
};
